import type {
  TrainingFollowUpWithUrgenciesVM,
  TrainingFollowUpPaginationParams,
} from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTrainingFollowUps = createApiThunk<
  PaginatedResult<TrainingFollowUpWithUrgenciesVM>,
  TrainingFollowUpPaginationParams
>("trainingFollowUps/adminRetrieveTrainingFollowUps", async (params: TrainingFollowUpPaginationParams, { extra: { adminRepository } }) => {
  return adminRepository!.adminGetAll(params);
});
